import { TooltipProps } from "@mui/material";
import { debounce } from "lodash";
import { RefObject, useEffect, useState } from "react";

export const useTooltipPlacement = (
  // eslint-disable-next-line no-undef
  ref: RefObject<HTMLElement>
): TooltipProps["placement"] => {
  const [placement, setPlacement] =
    useState<TooltipProps["placement"]>("right");

  useEffect(() => {
    const onScroll = debounce(() => {
      if (!ref.current) return;

      // eslint-disable-next-line no-undef
      const { scrollY } = window;
      const { top } = ref.current.getBoundingClientRect();

      if (top < scrollY) {
        setPlacement("top");
        return;
      }

      setPlacement("right");
    }, 300);

    // eslint-disable-next-line no-undef
    window.addEventListener("scroll", onScroll);

    return () => {
      // eslint-disable-next-line no-undef
      window.removeEventListener("scroll", onScroll);
    };
  }, [placement, ref]);

  return placement;
};
